import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";

export const inputClass =
  "block w-full rounded-xl border border-slate-900/12 bg-white px-3.5 text-[15px] text-slate-900 shadow-[0_1px_2px_rgb(15_23_42/0.04)] transition-[border-color,box-shadow] placeholder:text-slate-400 hover:border-slate-900/20 focus:border-primary focus:outline-none focus:ring-4 focus:ring-primary/12 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500 aria-[invalid=true]:border-danger aria-[invalid=true]:focus:ring-danger/12";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  leading?: ReactNode;
  trailing?: ReactNode;
  inputSize?: "sm" | "md";
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ className, leading, trailing, inputSize = "md", ...props }, ref) {
  const h = inputSize === "sm" ? "h-9 text-sm" : "h-11";
  if (!leading && !trailing) return <input ref={ref} className={cn(inputClass, h, className)} {...props} />;
  return (
    <div className="relative">
      {leading ? <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-slate-400 [&_svg]:size-4">{leading}</span> : null}
      <input ref={ref} className={cn(inputClass, h, leading && "pl-10", trailing && "pr-11", className)} {...props} />
      {trailing ? <span className="absolute inset-y-0 right-1 flex items-center">{trailing}</span> : null}
    </div>
  );
});
